import { Spinner } from "@fluentui/react-components";
import { Navigate, Outlet } from "react-router-dom";
import { useGetUserAccessLevel } from "../../hooks/useGetUserAccessLevel";

export function ImprovementLeaderExtRouteGuard() {
  const accessLevel = useGetUserAccessLevel();

  if (accessLevel === -1) return <Spinner />;
  if (accessLevel < 2) return <Navigate to="/" replace />;
  return <Outlet />;
}
